/* ($(document).ready(function(){
  // Activation du menu sidebar left
  $('.burger-menu').on('click', function (e) {
    $('#menu-burger-menu').toggleClass("open");
    e.preventDefault();
  });
})); */

(function ($, root, undefined) {

	$(function () {

		'use strict';

    // Fonction fixe navigation

    fixeNav();

    function fixeNav() {
      var header = $(".header");
      $(window).scroll(function() {
        var scroll = $(window).scrollTop();
          if (scroll >= 60) {
              header.addClass("navfixed");
          } else {
              header.removeClass("navfixed");
          }
      });
    }

    // $(window).scroll(function() {
    //   var scroll = $(window).scrollTop();
    //   $(".zoom").css({
    //   backgroundSize: (100 + scroll/20)  + "%",
    //   bottom: -(scroll/10)  + "%",
    //       });
    // });

    initSite();

    function initSite() {

      // Detetection du touch avec Modernizr pour remove pop sur vidéos

      // if ($('html').hasClass('no-touch')) {
      //   // alert("No touch !!")
      //   $('.linkPop').vanillabox({
      //     type: 'iframe',
      //     preferredWidth: 1024,
      //     preferredHeight: 576,
      //     closeButton: true,
      //     repositionOnScroll: true,
      //     grouping: false
      //   });

      // } else {
      //   // alert("touch !!")
      //   $('#realisations a').removeClass('videos-pop');
      //   $("#realisations a").attr( "target", "_blank" );
      // }


      // https://github.com/nextapps-de/spotlight

      // Si l'on est sur la Home

      // Effets apparitions
      // https://scrollrevealjs.org/api/reveal.html

      window.sr = ScrollReveal({ reset: false });

      sr.reveal('.effetReveal.gauche', {
        duration: 600,
        delay: 300,
        scale: 1,
        mobile: false,
        useDelay: 'once',
        origin: 'left',
        distance: '50px',
        easing: 'ease',
        viewFactor: 0.5
      });

      sr.reveal('.effetReveal.droite', {
        duration: 600,
        delay: 300,
        scale: 1,
        mobile: false,
        useDelay: 'once',
        origin: 'right',
        distance: '50px',
        easing: 'ease',
        viewFactor: 0.5
      });

      sr.reveal('.effetReveal.haut', {
        duration: 600,
        delay: 300,
        scale: 1,
        mobile: false,
        useDelay: 'once',
        origin: 'top',
        distance: '50px',
        easing: 'ease',
        viewFactor: 0.5
      }, 200);

      sr.reveal('.effetReveal.bas', {
        duration: 600,
        scale: 1,
        mobile: false,
        useDelay: 'once',
        origin: 'bottom',
        distance: '50px',
        easing: 'ease',
        viewFactor: 0.5
      }, 200);

      // OwlCarousel 2
      // https://owlcarousel2.github.io/OwlCarousel2/
      $("#carouselTemoignages").owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        navText: [ '', '' ],
        dots: true,
        autoplay:true,
        autoplayTimeout: 6000,
        autoplayHoverPause: true,
        responsiveClass: true,
        smartSpeed: 1500
      });

      $("#sliderPhotos").owlCarousel({
        nav : false,
        slideSpeed : 600,
        paginationSpeed: 1000,
        smartSpeed: 1000,
        singleItem:true,
        items: 1,
        loop: true,
        autoplay: true
      });

      $(".owl-carousel").owlCarousel({
        nav: true,
        loop:false,
        dots: false,
        pagination: false,
        margin: 25,
        autoHeight: false,
        stagePadding: 50,
        responsive:{
          0:{
            items: 1,
            stagePadding: 0,
            margin: 30
          },
          400:{
            items: 1,
            stagePadding: 50
          },
          610:{
            items: 3,
            stagePadding: 25
          },
          890:{
            items: 4,
            stagePadding: 25
          },
          1300:{
            items: 5,
            stagePadding: 25
          }
        }
      });
    }
	});

})(jQuery, this);
